module.exports = __webpack_public_path__ + "static/media/mobile-promotion_content.a03c4527.png";